export interface LoginPayload {
  username: string;
  password: string;
  newPassword?: string;
  rememberMeDeviceToken?: string | null;
}

export enum SignInServerErrorText {
  CREDENTIALS_ARE_INCORRECT = 'username or password is incorrect',
}

export enum SignInErrorCode {
  UNCONFIRMED_USER_ERROR_CODE = '40108',
  ATTEMPTS_LIMIT_ERROR_CODE = '40111',
  CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED = '40120'
}

export const USERNAME_QUERY_KEY = 'username';
export const SIGN_IN_STEP_PARAM_KEY = 'step';

export enum STEPS {
  SIGN_IN = 'SignIn',
  FORGOT_USERNAME = 'forgotUsername',
  FORGOT_USERNAME_SUCCESS = 'forgotUsernameSuccess',
  FORGOT_PASSWORD = 'forgotPassword',
  NEW_PASSWORD = 'newPassword',
  FORGOT_PASSWORD_SUCCESS = 'forgotPasswordSuccess',
}
